export interface Review {
  name: string;
  text: string;
  rating: number;
}

export const reviews: Review[] = [
  {
    name: "Maéva",
    text: "Une entreprise très professionnelle, un accueil agréable autant administratif que garagiste.",
    rating: 5,
  },
  {
    name: "Audrey",
    text: "Une enseigne sérieuse et professionnelle. Très contente de mon achat et de la qualité de service de toute l'équipe.",
    rating: 5,
  },
  {
    name: "Karene",
    text: "Une excellente expérience du début jusqu'à la fin. L'accueil est au top et à l'écoute.",
    rating: 5,
  },
];